import React, { Component } from "react"

import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups.js"

import {
    StatisticNameLegislativeFilter,
    StatisticNameDemographicFilter,
} from "shared/search/containers/Filter/StatisticFilters"

export class StatisticLegislativeFilterGroup extends Component {
    static defaultProps = {
        filters: [StatisticNameLegislativeFilter],
        uniqueFilterGroupId: "statLegFilterGroup",
        displayLabel: "Legislative Statistics",
        helpText: "Filter for legislative statistics.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class StatisticDemographicFilterGroup extends Component {
    static defaultProps = {
        filters: [StatisticNameDemographicFilter],
        uniqueFilterGroupId: "statDemFilterGroup",
        displayLabel: "Demographic Statistics",
        helpText: "Filter for demographic statistics.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}
